<div class="form-sec-col panel" [formGroup]="form">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      Search
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">
    <mat-form-field class="grow">
      <input matInput type="text" placeholder="Search key word" formControlName="search">
    </mat-form-field>

    <div class="button-row">
      <button type="button" mat-stroked-button color="primary" (click)="reset()">Reset</button>
      <button type="submit" mat-stroked-button color="accent" (click)="search()">Submit</button>
    </div>
    <br><br>{{form.value | json}} <br><br>{{form.valid}}
  </div>
</div>